import { Switch, Route } from "wouter";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import { ProtectedRoute } from "@/lib/protected-route";
import HomePage from "@/pages/home-page";
import AuthPage from "@/pages/auth-page";
import TherapistsPage from "@/pages/therapists-page";
import TherapistProfile from "@/pages/therapist-profile";
import BookingPage from "@/pages/booking-page";
import SessionsPage from "@/pages/sessions-page";
import CheckoutPage from "@/pages/checkout-page";

function Router() {
  return (
    <Switch>
      <ProtectedRoute path="/" component={HomePage} />
      <Route path="/auth" component={AuthPage} />
      <ProtectedRoute path="/therapists" component={TherapistsPage} />
      <ProtectedRoute path="/therapist/:id" component={TherapistProfile} />
      <ProtectedRoute path="/booking" component={BookingPage} />
      <ProtectedRoute path="/sessions" component={SessionsPage} />
      <ProtectedRoute path="/checkout/:therapistId/:date" component={CheckoutPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <TooltipProvider>
      <Toaster />
      <Router />
    </TooltipProvider>
  );
}

export default App;
